export default "__VITE_ASSET__DWCqvHmq__"